import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useDownloadResultsApi = () => {
  const call = useCallback(
    (params?: { importId: number; fileType: string }) =>
      axiosInstance(api.importExceptions(params?.importId as number, params?.fileType as string)),
    []
  );
  const { execute, isLoading } = useAsync(call, false);
  return { execute, isLoading };
};
export default useDownloadResultsApi;
